import Vue from 'vue'
import kebabCase from 'lodash/kebabCase'
import VueCurrencyInput from 'vue-currency-input'

const requireComponent = require.context('./', true, /\.vue$/)

export default {
    init() {
        // For each matching file name...
        requireComponent.keys().forEach((fileName) => {
            const componentConfig = requireComponent(fileName);

            const componentName =  kebabCase(
                fileName
                // Remove the "./_" from the beginning
                .replace(/^\.\/_/, '')
                // Remove the file extension from the end
                .replace(/\.\w+$/, '')
            )

            // Globally register the component
            Vue.component('kt-'+componentName, componentConfig.default || componentConfig)
        })

        const pluginOptions = {
            /* see config reference */
            globalOptions: { currency: 'RLS', locale: 'en'}
        }
        Vue.use(VueCurrencyInput, pluginOptions)
    }
}